import React from 'react';
import PropTypes from 'prop-types';

import Footer from '../../../../components/global/Footer';
import HeaderLanding from '../../../../components/global/HeaderLanding';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

const LandingPageLayout = ({ children }) => (
  <div className="wrapper-main">
    <HeaderLanding />
    <div className="content-wrap content-wrap-gray">{children}</div>
    <Footer />
  </div>
);

LandingPageLayout.propTypes = propTypes;

export default LandingPageLayout;
